import { Directive, HostBinding, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { LeadInjector } from 'src/app/core/models/lead/lead-injector.model';

@Directive({
    selector: '[appInjectorCurlSnipped]',
    standalone: false
})
export class InjectorCurlSnippedDirective {

  @Input() injector!: LeadInjector
  
  @HostBinding('innerText') content = ''

  constructor( private ngControl: NgControl) { }

  ngOnInit(): void {
    this.ngControl.control?.setValue(this.getContent(this.injector.injectionEndpoint))
  }

  private getContent(endpoint: string): string {
    return `curl "${endpoint}" --data-raw "nome=mario&cognome=rossi&tel=3330452349&mail=mario.rossi@example.com&piva=&indirizzo=via+Manzoni&provincia=MI&nota1=&nota2="`
  }


}
